import { render, staticRenderFns } from "./ModalConfirmUpdateOrderStatus.vue?vue&type=template&id=0fefda5c&scoped=true&"
import script from "./ModalConfirmUpdateOrderStatus.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmUpdateOrderStatus.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfirmUpdateOrderStatus.vue?vue&type=style&index=0&id=0fefda5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fefda5c",
  null
  
)

export default component.exports